import React  from 'react';
import { Menu , Button, Divider} from 'antd';
import { WEB_RELEASE_VERSION } from './../../app.config';
import { 
  checkSearchPage,
  checkCancelPage,
  checkViewNotificationPage,
  checkBusCancellationPage,
  checkStaffPage,
  viewBookedTicketsReport,
  viewMasterTripReport,
  viewPassengerInfoReport,
  viewSalesReport,
  viewSharedTripSalesReport,
  viewMasterAgentSalesReport,
  viewTicketSearchReport,
  viewTicketSearchReportOld,
  viewRescheduledTicketReport,
  viewTripReport,
  blockedSeatsReport,
  viewPerformanceReport,
  viewTotalTransactionReport,
  cancelledSeatsReport,
  checkViewAbandonedReport,
  checkWebTicketSalesReport,
  checkWebTicketCancelReport,
  viewSmsReport,
  viewTicketBookedAfterTripStartTime,
  checkAgentsPage,
  checkAgentsTransactionPage,
  checkAgentLedgerPage,
  checkToViewSystemInfoPage,
  viewSettlementReport,
  tripExpenseReport,
  checkToViewTripsPageOfAdmin,
  checkToViewBulkTripVehicleUpdatePage,
  checkToViewPopularRoutesPageAdmin,
  checkToViewSchedulesPageOfAdmin,
  checkToViewAgentsPageOfAdmin,
  viewDemandDataReport,
  viewServiceCountReport,
  viewOccupancyReport,
  viewCostSummaryReportReport,
  viewTransactionSummaryReportReport,
  tripCreate,
  checkToViewStandardStopsPage,
  checkToViewTripSheetPermissionPage,
  viewTicketSharingReport,
  viewRevenueReport,
  viewBusServiceCollectionReport,
  checkToViewCitiesPageAdmin,
  checkPrepaidOTAPage,
  checkToViewAddressBookPageAdmin,
  viewPrePaidReport,
  viewTrackingSummaryReport,
  checkToViewUserActions,
  checkDashBoardPage,
  checkToViewOperatorConfig,
  checkToViewBusOperatorPage,
  checkToViewColourConfig,
  checkToViewOperatorWebsiteConfig,
  checkToViewExpenseConfig,
  checkToViewVechicleManagementPageAdmin,
  checkToViewTemporaryChangesPage,
  checkToViewBusesPageAdmin,
  checkToViewCancellationPolicyPage,
  checkToViewMetaDataPage,
  checkToViewTicketImportPage,
  checkToViewOtaSearchPage,
  checkOtherReport,
  checkRevenueReport,
  viewDriverAttendanceReport,
  viewExpenseReport,
  viewStopAnalysisReport,
  checkToViewBookingConfig,
  checkToViewBillingConfig,
  checkToViewDiscountConfig,
  viewSettlementAdmin,
  viewOwnSettlement,
  checkToSetSettlementOpeningBalance,
  checkToGenerateSettlementDraft
 } from './app.header.module';
import { dafidyUserCheck } from './../../utils/constant';
import { useLocation } from 'react-router-dom'

const { SubMenu } = Menu;

export const MenuMobile = (props) => {

  const {
    onClickAddressBookPage,
    onTicketSearchReportClick,
    onTicketSearchV2ReportClick,
    onRescheduledTicketReportClick,
    onMasterTripSheetReport,
    onViewPassengerInfoReportClick,
    onSalesReportClick,
    onSharedTripSalesReportClick,
    onMasterAgentSalesReportClick,
    onExpenseReportClick,
    onBookedTicketsClick,
    onTripSheetClick,
    logout,
    changePassword,
    viewCancelClick,
    searchClick,
    onClick,
    userName,
    onBlockedReportClick,
    performanceReport,
    totalTransactionReport,
    cancelledSeatsReportClick,
    viewAbandonedReportClick,
    webTicketSalesReportClick,
    webTicketCancelReportClick,
    onClickSmsReport,
    onClickTicketsBookedAfterTripStartTime,
    onClickAgentTransactionsPage, 
    onClickAgentLedgerPage,
    onClickAgentTripSheetPermissionPage,
    onClickAgentsPage,
    tripExpenseClick,
    onClickSettlementReport,
    onClickGstFilingReport,
    onClickDemandDataReport,
    onClickServiceCountReport,
    onClickOccupancyReport,
    onClickCostSummaryReport,
    onClickTransactionSummaryReport,
    onClickTrackingSummaryReport,
    onClickNewTrip,
    onClickStandardStops,
    openAdminTripsPage,
    openBulkTripVehicleUpdatePage,
    openAdminAgentsPage,
    staffClick,
    tripCreatePage,
    openSchedulesPage,
    popularRoutesPage,
    userActionsPage,
    operatorConfigClick,
    qbccConfigClick,
    busOperatorClick,
    settlementsOpeningBalanceClick,
    settlementsGenerateClick,
    settlementBillingClick,
    settlementsHistoryClick,
    bookingConfigClick,
    billingConfigClick,
    colourConfigClick,
    operatorWebsiteConfigClick,
    expenseConfigClick,
    discountConfigClick,
    onClickTicketSharing,
    onClickRevenue,
    onClickBusServiceCollectionReport,
    onClickTransactions,
    onClickCitiesPage,
    onPrepaidOTADashboardClick,
    dashboardClick,
    checkToViewServiceAccessPage,
    serviceAccessPage,
    checkToViewServiceSharingPage,
    serviceSharingPage,
    checkToViewBookingPartnersPage,
    bookingPartnersPage,
    openAdminVechicleManagementPage,
    onClickTemporaryChanges,
    openAdminBusesPage,
    openCancellationPolicyPage,
    openCoachTypesPage,
    openThemeColorsPage,
    openRedbusCitiesPage,
    openTicketImportPage,
    onClickSystemInfoPage,
    onClickOtaSearchPage,
    onClickDriverAttendanceReport
  }=props;
  
  const location = useLocation()

  return (
    <Menu onClick={onClick} defaultSelectedKeys={[location.pathname]}>
                {checkDashBoardPage()&&
                  <Menu.Item key="/dashboard" onClick={dashboardClick}>Dashboard</Menu.Item>
                }
                {checkSearchPage()&&
                <Menu.Item key="/home" onClick={searchClick}>Search</Menu.Item>
                }
                {checkToViewOtaSearchPage()&&
                <Menu.Item key="/ota-search" onClick={onClickOtaSearchPage}>OTA Search</Menu.Item>
                }
                {viewTicketSearchReport()&&
                <Menu.Item key="/view-ticket-search" onClick={onTicketSearchV2ReportClick}>Ticket Search</Menu.Item>
                }
                {checkCancelPage()&&
                <Menu.Item key="/view-cancel" onClick={viewCancelClick}>Modify/Cancel</Menu.Item>
                }
                {checkPrepaidOTAPage()&&
                <Menu.Item key="/prepaid-ota" onClick={onPrepaidOTADashboardClick}>Dashboard</Menu.Item>
                }
                <SubMenu key="report" title="Report" style={{backgroundColor:'red'}}>
                  {viewTripReport()||viewMasterTripReport()?
                    <SubMenu title="Trip Sheet">
                        {viewTripReport()&&
                          <Menu.Item key="/report/tripsheet" onClick={onTripSheetClick}>Trip Sheet</Menu.Item>
                        }
                        {viewMasterTripReport()&&
                          <Menu.Item key="/report/mastertripsheetreport" onClick={onMasterTripSheetReport}>Master Trip Sheet Report</Menu.Item>
                        }
                    </SubMenu>
                    :null
                  }
                  {viewSalesReport()||viewSharedTripSalesReport()||viewMasterAgentSalesReport()||viewBookedTicketsReport()?
                    <SubMenu title="Sales">
                      {viewSalesReport()&&
                        <Menu.Item key="/report/salesreport" onClick={onSalesReportClick}>Sales Report</Menu.Item>
                      }
                      {viewSharedTripSalesReport()&&
                        <Menu.Item key="/report/sharedtripsales" onClick={onSharedTripSalesReportClick}>Shared Trip Sales</Menu.Item>
                      }
                      {viewMasterAgentSalesReport()&&
                        <Menu.Item key="/report/masteragentsalesreport" onClick={onMasterAgentSalesReportClick}>Master Agent Sales Report</Menu.Item>
                      }
                      {viewBookedTicketsReport()&&
                        <Menu.Item key="/report/bookedtickets" onClick={onBookedTicketsClick}>Booked Tickets</Menu.Item>
                      }
                  </SubMenu>
                  :null
                  }
                  {checkWebTicketSalesReport()||checkWebTicketCancelReport()?
                  <SubMenu title="Web Tickets">
                      {checkWebTicketSalesReport()&&
                        <Menu.Item key="/report/webticketsalesreport" onClick={webTicketSalesReportClick}>Web Ticket Sales Report</Menu.Item>
                      }
                      {checkWebTicketCancelReport()&&
                        <Menu.Item key="/report/webticketcancelreport" onClick={webTicketCancelReportClick}>Web Ticket Cancellation Report</Menu.Item>
                        }
                  </SubMenu>
                  :null
                  }
                  {checkRevenueReport()?
                  <SubMenu title="Revenue">
                    {viewTotalTransactionReport()&&
                      <Menu.Item key="/report/totaltransactionreport" onClick={totalTransactionReport}>Total Transaction Summary</Menu.Item>
                    }
                    {viewPerformanceReport()&&
                      <Menu.Item key="/report/performancereport" onClick={performanceReport}>Performance Report</Menu.Item>
                    }
                    {viewSettlementReport()&&
                      <Menu.Item key="/report/settlementreport" onClick={onClickSettlementReport}>Settlement Report</Menu.Item>
                    }
                    {viewSettlementReport()&&
                      <Menu.Item key="/report/gstfilingreport" onClick={onClickGstFilingReport}>GST Filing Report</Menu.Item>
                    }
                    {viewCostSummaryReportReport()&&
                      <Menu.Item key="/report/costSummaryReport" onClick={onClickCostSummaryReport}>Billing Report</Menu.Item>
                    }
                    {viewTransactionSummaryReportReport()&&
                      <Menu.Item key="/report/transactionSummaryReport" onClick={onClickTransactionSummaryReport}>Transaction Summary</Menu.Item>
                    }
                    {viewRevenueReport()&&
                      <Menu.Item key="/report/revenuereport" onClick={onClickRevenue}>Expected Revenue Report</Menu.Item>
                    }
                    {viewPrePaidReport()&&
                      <Menu.Item key="/report/prepaidtransactions" onClick={onClickTransactions}>Prepaid Transactions</Menu.Item>
                    }
                    {checkViewAbandonedReport()&&
                      <Menu.Item key="/report/abandonedreport" onClick={viewAbandonedReportClick}>Abandoned Transactions Report</Menu.Item>
                    }
                    {viewBusServiceCollectionReport()&&
                      <Menu.Item key="/report/busservicecollection" onClick={onClickBusServiceCollectionReport}>Bus Service Collection</Menu.Item>
                    }
                  </SubMenu>
                  :null
                  }
                  {checkOtherReport()?
                   <SubMenu title="Other Reports">
                        
                        {cancelledSeatsReport()&&
                        <Menu.Item key="/report/cancelledticketreport" onClick={cancelledSeatsReportClick}>Ticket Cancellation Report</Menu.Item>
                        }
                        {blockedSeatsReport()&&
                        <Menu.Item key="/report/blockedreport" onClick={onBlockedReportClick}>Blocked Tickets</Menu.Item>
                        }
                        {viewPassengerInfoReport()&&
                        <Menu.Item key="/report/viewpassengersreport" onClick={onViewPassengerInfoReportClick}>Frequent Travellers Report</Menu.Item>
                        }
                        {viewTicketSearchReportOld()&&
                        <Menu.Item key="/report/ticketsearchreport" onClick={onTicketSearchReportClick}>Ticket Search</Menu.Item>
                        }
                        {viewRescheduledTicketReport()&&
                        <Menu.Item key="/report/rescheduledTicketreport" onClick={onRescheduledTicketReportClick}>Rescheduled Ticket</Menu.Item>
                        }
                        {viewSmsReport()&&
                        <Menu.Item key="/report/smsreport" onClick={onClickSmsReport}>SMS Report</Menu.Item>
                        }
                        {viewTicketBookedAfterTripStartTime()&&
                        <Menu.Item key="/report/ticketbookedafterdeparture" onClick={onClickTicketsBookedAfterTripStartTime}>Tickets Booked After Departure</Menu.Item>
                        }
                        {viewDemandDataReport()&&
                        <Menu.Item key = "/report/demandDataReport" onClick = {onClickDemandDataReport}>Demand Data Report</Menu.Item>
                        }
                        {viewServiceCountReport()&&
                        <Menu.Item key = "/report/viewServiceCountReport" onClick = {onClickServiceCountReport}>Service Count</Menu.Item>
                        }
                        {viewOccupancyReport()&&
                        <Menu.Item key = "/report/occupancyReport" onClick = {onClickOccupancyReport}>Occupancy Report</Menu.Item>
                        }
                        {viewTrackingSummaryReport()&&
                        <Menu.Item key = "/report/trackingSummaryReport" onClick = {onClickTrackingSummaryReport}>Tracking Summary</Menu.Item>
                        }
                        {viewTicketSharingReport()&&
                        <Menu.Item key = "/report/ticketsharingreport" onClick = {onClickTicketSharing}>Seat Sharing Report</Menu.Item>
                        }
                        {viewDriverAttendanceReport()&&
                        <Menu.Item key = "/report/driverAttendanceReport" onClick = {onClickDriverAttendanceReport}>Driver Attendance</Menu.Item>
                        }
                        {viewExpenseReport()&&
                          <Menu.Item key="/report/expense-report" onClick={onExpenseReportClick}>Expense Report</Menu.Item>
                        }
                        {viewStopAnalysisReport()&&
                        <Menu.Item key="/report/stop-analysis" onClick={props.onStopAnalysisReportClick}>Stops Analysis</Menu.Item>
                        }
                  </SubMenu>
                  :null
                  }
                 
                </SubMenu>
                {checkToViewOperatorConfig()||checkToViewColourConfig()||checkToViewOperatorWebsiteConfig()||checkToViewCitiesPageAdmin()||checkToViewAddressBookPageAdmin()||checkToViewAgentsPageOfAdmin()||checkToViewTripsPageOfAdmin()||checkToViewBulkTripVehicleUpdatePage()||checkToViewSchedulesPageOfAdmin()||checkToViewPopularRoutesPageAdmin()||checkToViewStandardStopsPage()||checkToViewCancellationPolicyPage()||checkToViewMetaDataPage()||checkToViewTicketImportPage()||viewSettlementAdmin()||viewOwnSettlement()||checkToSetSettlementOpeningBalance()||checkToGenerateSettlementDraft()||checkToViewBusOperatorPage()||dafidyUserCheck()?
                   <SubMenu key="admin" title="Admin">
                    <SubMenu key="admin-trip" title="Trip">
                      {checkToViewTemporaryChangesPage()&&
                        <Menu.Item key="/admin/temporary-changes" onClick={onClickTemporaryChanges}>
                          Temporary Changes
                        </Menu.Item>
                      }
                      {checkToViewCitiesPageAdmin()&&
                        <Menu.Item key="/admin/cities" onClick={onClickCitiesPage}>Cities</Menu.Item>
                      }
                      {checkToViewAddressBookPageAdmin()&&
                        <Menu.Item key="/admin/addressbook" onClick={onClickAddressBookPage}>Address Book</Menu.Item>
                      }
                      {checkToViewTripsPageOfAdmin()&&
                        <Menu.Item key="/admin/trips" onClick={openAdminTripsPage}>Trips</Menu.Item>
                      }
                      {checkToViewTripsPageOfAdmin()&&
                        <Menu.Item key="/new-trip" onClick={onClickNewTrip}>In active trips</Menu.Item>
                      }
                      {checkToViewBulkTripVehicleUpdatePage()&&
                        <Menu.Item key="/admin/bulk-trip-vehicle-update" onClick={openBulkTripVehicleUpdatePage}>Bulk Trip Vehicle Update</Menu.Item>
                      }
                      {checkToViewStandardStopsPage()&&
                      <Menu.Item key="/standard-stops" onClick={onClickStandardStops}>Standard stops</Menu.Item>
                      }
                      {checkToViewSchedulesPageOfAdmin()&&
                      <Menu.Item key="/schedules" onClick={openSchedulesPage}>Schedules</Menu.Item>
                      }
                      {tripCreate()&&
                        <Menu.Item key= "/trip-create" onClick= {tripCreatePage}>Create Trip</Menu.Item>
                      }
                      {checkToViewPopularRoutesPageAdmin()&&
                        <Menu.Item key= "/popular-routes" onClick= {popularRoutesPage}>Popular Routes</Menu.Item>
                      }
                    </SubMenu>
                    <SubMenu key="admin-other" title="Other">
                      {checkToViewAgentsPageOfAdmin()&&
                        <Menu.Item key="/admin/users" onClick={openAdminAgentsPage}>Users</Menu.Item>
                      }
                      {checkStaffPage()&&
                        <Menu.Item key="/staff" onClick={staffClick}>Staff</Menu.Item>
                      }
                      {checkToViewVechicleManagementPageAdmin()&&
                      <Menu.Item key= "/vehicle-management" onClick= {openAdminVechicleManagementPage}>Vehicle Management</Menu.Item>
                      }
                      {checkToViewBusesPageAdmin()&&
                      <Menu.Item key= "/buses" onClick= {openAdminBusesPage}>Buses</Menu.Item>
                      }
                      {checkToViewCancellationPolicyPage()&&
                      <Menu.Item key= "/cancellation-policy" onClick= {openCancellationPolicyPage}>Cancellation Policy</Menu.Item>
                      }
                      {checkToViewTicketImportPage()&&
                      <Menu.Item key="/admin/ticket-import" onClick={openTicketImportPage}>Ticket Import</Menu.Item>
                      }
                    </SubMenu>
                    {(checkToViewBookingConfig()||checkToViewBillingConfig()||checkToViewOperatorConfig()||checkToViewColourConfig()||checkToViewOperatorWebsiteConfig()||checkToViewExpenseConfig()||checkToViewBusOperatorPage()||checkToViewDiscountConfig()) &&
                      <SubMenu key="admin-config" title="Config">
                        {checkToViewOperatorConfig()&&
                        <Menu.Item key= "/operatorconfig" onClick= {operatorConfigClick}>Operator Config</Menu.Item>
                        }
                        {checkToViewOperatorConfig()&&
                        <Menu.Item key= "/admin/qbcc-config" onClick= {qbccConfigClick}>QBCC Config</Menu.Item>
                        }
                        {checkToViewBusOperatorPage()&&
                        <Menu.Item key= "/admin/bus-operator" onClick= {busOperatorClick}>Bus Operator</Menu.Item>
                        }
                        {checkToViewColourConfig()&&
                        <Menu.Item key= "/colourconfig" onClick= {colourConfigClick}>Colour Config</Menu.Item>
                        }
                        {checkToViewOperatorWebsiteConfig()&&
                        <Menu.Item key= "/admin/operator-website-config" onClick= {operatorWebsiteConfigClick}>Operator Website Config</Menu.Item>
                        }
                        {checkToViewExpenseConfig()&&
                        <Menu.Item key= "/expenseconfig" onClick= {expenseConfigClick}>Expense Config</Menu.Item>
                        }
                        {checkToViewBookingConfig()&&
                        <Menu.Item key="/admin/booking-config" onClick={bookingConfigClick}>Booking Config</Menu.Item>
                        }
                        {checkToViewBillingConfig()&&
                        <Menu.Item key="/admin/billing-config" onClick={billingConfigClick}>Billing Config</Menu.Item>
                        }
                        {checkToViewDiscountConfig()&&
                        <Menu.Item key="/admin/discount-config" onClick={discountConfigClick}>Discount Config</Menu.Item>
                        }
                      </SubMenu>
                    }
                    {(viewSettlementAdmin() || checkToSetSettlementOpeningBalance() || checkToGenerateSettlementDraft()) &&
                      <Menu.Item key="/settlements" onClick={settlementsGenerateClick}>Settlements</Menu.Item>
                    }
                    {(viewOwnSettlement()) &&
                      <Menu.Item key="/settlement-billing" onClick={settlementBillingClick}>Billing & Settlements</Menu.Item>
                    }
                    {(checkToViewMetaDataPage() || dafidyUserCheck()) &&
                      <SubMenu key="admin-metadata" title="Metadata">
                        {checkToViewMetaDataPage() &&
                        <Menu.Item key="/admin/metadata/coach-types" onClick={openCoachTypesPage}>
                          Coach Types
                        </Menu.Item>
                        }
                        {dafidyUserCheck() &&
                        <Menu.Item key="/admin/metadata/theme-colors" onClick={openThemeColorsPage}>
                          Theme Colors
                        </Menu.Item>
                        }
                      </SubMenu>
                    }
                    {dafidyUserCheck() &&
                      <Menu.Item key="/admin/redbus-cities" onClick={openRedbusCitiesPage}>Redbus Cities</Menu.Item>
                    }
                  </SubMenu>
                  :
                  null
                }
                {checkToViewSchedulesPageOfAdmin()&&
                  <Menu.Item key="/schedules" onClick={openSchedulesPage}>
                    Schedules
                  </Menu.Item>
                 }
                <SubMenu key="profile" title="Profile">
                    {checkToViewUserActions()&&
                        <Menu.Item key= "/user-actions" onClick= {userActionsPage}>Roles & Permissions</Menu.Item>
                    }
                    {checkToViewTripSheetPermissionPage()&&
                      <Menu.Item key="accounts/trip-sheet-permission" onClick={onClickAgentTripSheetPermissionPage}>Trip Sheet Permissions</Menu.Item>
                    }  
                    {checkToViewServiceAccessPage()&&
                      <Menu.Item key="/users/service-access" onClick={serviceAccessPage}>Service Access</Menu.Item>
                    }
                    {checkToViewServiceSharingPage()&&
                      <Menu.Item key="/users/service-sharing" onClick={serviceSharingPage}>Service Sharing</Menu.Item>
                    }
                    {checkToViewBookingPartnersPage()&&
                      <Menu.Item key="/users/booking-partners" onClick={bookingPartnersPage}>Booking Partners</Menu.Item>
                    }
                    {checkAgentsPage()&&
                      <Menu.Item key="/accounts/agents" onClick={onClickAgentsPage}>Agent Wallets</Menu.Item>
                    }
                    {checkAgentsTransactionPage()&&
                      <Menu.Item key="/accounts/agent-transactions" onClick={onClickAgentTransactionsPage}>Agent Transactions</Menu.Item>
                    }
                    {checkAgentLedgerPage()&&
                      <Menu.Item key="/accounts/agent-ledger" onClick={onClickAgentLedgerPage}>Agent Ledger</Menu.Item>
                    }
                        
                    <Divider />
                    {checkToViewSystemInfoPage()&&
                      <Menu.Item key="/system-info" onClick={onClickSystemInfoPage}>System Info</Menu.Item>
                    }
                  <Menu.Item key="/change-password" onClick={changePassword}>Change Password</Menu.Item>
                  <Menu.Item key="/log-out" onClick={logout}>Logout</Menu.Item>
                </SubMenu>
            <Button type="text" className="outline-button">{userName+" "+WEB_RELEASE_VERSION}</Button>
    </Menu>
  );
};